import axiosInstance from "../utils/axios";

export const AddCourseLandingPages = async (data) => {
    return await axiosInstance().post('/insertCourseLandingPages', data)
}

export const updateCourseLandingPages = async (data) => {
    return await axiosInstance().post(`/updateCourseLandingPages`, data)
}

export const getCourseLandingCategoryDropdown = async () => {
    return await axiosInstance().post(`/getCourseLandingPagesFilter`)
}

export const GetCourseLandingPageListCancelToken = async (values, cancelToken) => {
    return await axiosInstance().post(`/getCourseLandingPagesList`, values, {
        cancelToken: cancelToken
    });
};

export const getCourseLandingPagesList = async (values) => {
    return await axiosInstance().post(`/getCourseLandingPagesList`, values);
};

export const DeleteCourseLandingPages = async (id) => {
    return await axiosInstance().delete(`/deleteCourseLandingPages?TrainingCourseLandingPageID=${id}`);
};

export const GetCourseLandingUpdateList = async (id) => {
    return await axiosInstance().get(`/getCourseLandingPages?TrainingCourseLandingPageID=${id}`);
};